"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.paymentDetailsReducer = exports.paymentDetailsInitialState = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var Actions = __importStar(require("./actions"));
var domain_1 = require("@genoa/domain");
exports.paymentDetailsInitialState = {
    label: '',
    date: '',
    dateWeekday: '',
    statusLabel: '',
    statusType: domain_1.StatusPillType.Dark,
    baseAmount: 0,
    processingFeePercentage: 0,
    processingFeeAmount: 0,
    totalAmount: 0,
    cardType: '',
    userPaymentPublicId: '',
    canPayNow: false,
    billDate: '',
    estimated: false,
    initialized: false,
    index: 0,
    category: domain_1.PaymentCategoryV2.DOWN_PAYMENT,
    ordinalPaymentLabel: '1st rent payment',
    canPreFund: false,
    status: domain_1.PaymentStatusV2.SCHEDULED,
    displayStatus: domain_1.DisplayStatus.SCHEDULED,
    isSecurityDeposit: false,
    canReschedule: false,
    propertyPassthroughFeeAmount: 0
};
exports.paymentDetailsReducer = (0, toolkit_1.createReducer)(exports.paymentDetailsInitialState, function (builder) {
    builder
        .addCase(Actions.resetPaymentDetailsAction, function (_state, _action) {
        return __assign({}, exports.paymentDetailsInitialState);
    })
        .addCase(Actions.setPaymentDetailsAction, function (_state, action) {
        return __assign(__assign({}, action.payload), { initialized: true });
    });
});
